import { AlertStack } from "./AlertStack";
import { ToastStack } from "./ToastStack";

/**
 * This is the entry point for rendering notifications, some notes:
 *
 * 1. Toasts are the smaller notifications at the center-bottom of the screen
 *    These are meant to be used for quick messages for which user actions are optional (eg. undo after success)
 *    They are rendered by <ToastStack />
 *
 * 2. Alerts are the bigger notifications on the left-bottom of the screen
 *    These are meant to interrupt the user work for important messages that might require actions.
 *    Note that they will also have a dismiss action.
 *    They are rendered by <AlertStack />
 *
 * 3. ??? New Global user notifications will most likely be added to this component in the future.
 */
export const GlobalNotifications: React.FC = () => {
  return (
    <>
      <ToastStack />
      <AlertStack />
    </>
  );
};
